import { Button, Stack } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { reset, selectSelectedQueryTool } from '../../../data-wrangler/dataWranglerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, SetStateAction } from 'react';
import ToolSelector from "../../../data-wrangler/components/ToolSelector";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

type Props = {
  openLoadQueryModal: boolean;
  setOpenLoadQueryModal: Dispatch<SetStateAction<boolean>>;
  openShareQueryModal: boolean;
  setOpenShareQueryModal:  Dispatch<SetStateAction<boolean>>;
  setSearchFilter: Dispatch<SetStateAction<string>>;
}

const QueryWizardHeader = ({ setOpenShareQueryModal, setOpenLoadQueryModal, setSearchFilter }: Props) => {
    const dispatch = useDispatch();
    const selectedQueryTool = useSelector(selectSelectedQueryTool);
    const resetQuery = () => {
        dispatch(reset({ "exemptKeys": { "selectedQueryTool": selectedQueryTool } }));
        setSearchFilter("");
    }

    return (
        <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection={"row"} alignItems={"center"} gap={3}>
                <Button
                    id={"query-wizard-reset-query-button"}
                    variant={"outlined"}
                    color={"error"}
                    size={"small"}
                    onClick={() => resetQuery()}
                >
          Reset Query
                </Button>
                <Button
                    id={"query-wizard-load-query-button"}
                    variant="tertiary"
                    size={"small"}
                    startIcon={<SaveOutlinedIcon />}
                    onClick={() => setOpenLoadQueryModal(true)}
                >
          Load Query
                </Button>
                <Button
                    id={"query-wizard-share-query-button"}
                    variant={"tertiary"}
                    size={"small"}
                    startIcon={<ShareIcon />}
                    onClick={() => setOpenShareQueryModal(true)}
                >
          Share
                </Button>
            </Stack>
            <ToolSelector />
        </Stack>
    )
}

export default QueryWizardHeader;
